import { createAction } from 'redux-actions';
import types from '../types';

export const confirmOwnership = createAction(types.CONFIRM_OWNERSHIP);
export const confirmOwnershipSucceeded = createAction(
  types.CONFIRM_OWNERSHIP_SUCCEEDED
);
export const confirmOwnershipFailed = createAction(types.CONFIRM_OWNERSHIP_FAILED);

